import { createReducer } from 'deox';
import { updateSiteOverviewDocActions } from '../actions';

export interface ContentDocState {
  siteOverviewHtml: string;
}

const initialState: ContentDocState = {
  siteOverviewHtml: '',
};

const siteOverviewReducer = createReducer(initialState, (handleAction) => [
  handleAction(updateSiteOverviewDocActions.updateSiteOverviewDoc, (state, { payload }) => ({
    siteOverviewHtml: payload.html,
  })),
]);

export default siteOverviewReducer;
